import { SxProps } from '@mui/material'

const styles = {
  container: {
    width: '100%',
    height: '100%',
    display: 'flex',
    flexDirection: 'column'
  } as SxProps,

  itemImage: {
    width: 60,
    height: 60,
    objectFit: 'contain',
    borderRadius: 1
  } as SxProps,

  itemContainer: {
    display: 'flex',
    alignItems: 'center',
    gap: 1
  } as SxProps,

  itemName: {
    fontWeight: 500,
    fontSize: '0.875rem',
    lineHeight: 1.2,
    maxWidth: 200,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap'
  } as SxProps,

  itemId: {
    fontSize: '0.75rem',
    color: 'text.secondary'
  } as SxProps,

  reference: {
    fontSize: '0.75rem',
    fontVariantNumeric: 'tabular-nums',
    lineHeight: 1.4,
    whiteSpace: 'nowrap'
  } as SxProps,

  url: {
    color: 'primary.main',
    textDecoration: 'none',
    fontSize: '0.875rem',
    '&:hover': {
      textDecoration: 'underline'
    }
  } as SxProps,

  deliveryAddress: {
    fontSize: '0.875rem',
    lineHeight: 1.3
  } as SxProps,

  deliveryWindow: {
    fontSize: '0.875rem',
    lineHeight: 1.3,
    textAlign: 'center'
  } as SxProps,

  travelerInfo: {
    fontSize: '0.875rem',
    lineHeight: 1.3
  } as SxProps
}

export default styles
